import type { Step } from 'react-joyride'
import { resolveStepElement } from './scroll-target-into-horizontal-view'

type GuidedTourStepData = { deferredTarget?: boolean }

function hasDeferredTarget(step: Step): boolean {
  return Boolean((step.data as GuidedTourStepData | undefined)?.deferredTarget)
}

export function filterAvailableSteps(steps: Step[]): Step[] {
  return steps.filter(
    (step) =>
      hasDeferredTarget(step) || Boolean(resolveStepElement(step.target)),
  )
}

export function hasRenderedTargets(steps: Step[]): boolean {
  return steps.some(
    (step) =>
      step.target !== 'body' && Boolean(resolveStepElement(step.target)),
  )
}
